import axios from "@/plugins/axios";

let url = "/api/v1/me/deposits";

/** @typedef {import('../../../../store/user-deposits').UserDeposit} $UserDeposit */

export const deposits = {
    /**
     * @param {import("axios").AxiosRequestConfig} data
     * @returns {Promise<{ summary: { totalCount: number }, deposits: $UserDeposit[]}>}
     */
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },

    /**
     * @param {{ _id: string }} data
     * @returns {Promise<{ deposit: $UserDeposit }>}
     */
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
};

export default deposits;
